import { Branch } from '@texas/api/endpoints/branchesApi';
import { PurchaseInformation } from '@texas/api/endpoints/purchaseInformationApi';
import { ExportArticleItem } from '@texas/api/endpoints/search/searchApi';
import { GarpData } from '@texas/api/endpoints/variantsApi';
import { SignalDispatcher } from 'ste-signals';
import { SimpleEventDispatcher } from 'ste-simple-events';

export interface EntityVisitedEvent {
  id: number;
  type: 'article' | 'customer' | 'concept' | 'supplier' | 'inquiry' | 'offer';
  label: string;
  navobj?: Record<string, number>;
}

export interface ExportArticleEvent {
  articles: ExportArticleItem[];
  branchIds: number[];
  hideBranchIds: boolean;
  template?: number;
}

export interface NavigationPath {
  to: string;
  navObj?: any;
  newTab?: boolean;
  options?: { location?: boolean | 'replace'; notify?: boolean };
}

export interface UpdateValue {
  id: number;
  value: string;
}

export interface LockedState {
  locked: boolean;
}

export interface Id {
  id: number;
}

export interface ConceptCreatedEvent {
  id: number;
  customerId: number;
}

export const reactEvents = {
  freightCostCreated: new SignalDispatcher(),
  handlingFeeCreated: new SignalDispatcher(),
  excelExportClicked: new SimpleEventDispatcher<ExportArticleEvent>(),
  routingChanged: new SimpleEventDispatcher<NavigationPath>(),
  variantFinalized: new SimpleEventDispatcher<GarpData>(),
  branchCreated: new SimpleEventDispatcher<Branch>(),
  supplierAdded: new SimpleEventDispatcher<PurchaseInformation>(),
  variantSupplierChanged: new SignalDispatcher(),
  supplierArchived: new SimpleEventDispatcher<number>(),
  supplierRestored: new SimpleEventDispatcher<number>(),
  supplierNameChanged: new SimpleEventDispatcher<UpdateValue>(),
  supplierBranchUpdated: new SimpleEventDispatcher<number>(),
  variantArchived: new SignalDispatcher(),
  variantRestored: new SignalDispatcher(),
  variantNameChanged: new SimpleEventDispatcher<UpdateValue>(),
  newOptionAddedWithVariant: new SignalDispatcher(),
  lockedStateChanged: new SimpleEventDispatcher<LockedState>(),
  supplierCreated: new SignalDispatcher(),
  newContactAddedToBrand: new SignalDispatcher(),
  conceptCreated: new SimpleEventDispatcher<ConceptCreatedEvent>(),
  conceptArchived: new SimpleEventDispatcher<number>(),
  conceptRestored: new SimpleEventDispatcher<number>(),
  conceptNameChanged: new SimpleEventDispatcher<UpdateValue>(),
  warningsChanged: new SignalDispatcher(),
  onMatrixColorAxisUpdate: new SimpleEventDispatcher<number>(),
  urlParamsChanged: new SimpleEventDispatcher<{ [key: string]: any }>(),
  garpDataUpdated: new SignalDispatcher(),
  variantOptionLinked: new SignalDispatcher(),
  customerArchived: new SimpleEventDispatcher<number>(),
  customerRestored: new SimpleEventDispatcher<number>(),
  customerNameChanged: new SimpleEventDispatcher<UpdateValue>(),
  entityVisited: new SimpleEventDispatcher<EntityVisitedEvent>(),
  articleVersionUpdated: new SignalDispatcher(),
  articleUpdated: new SimpleEventDispatcher<number>(),
  articleTasksChanged: new SimpleEventDispatcher<number>(),
  newArticleVariantRequested: new SignalDispatcher(),
  currentUserUpdated: new SignalDispatcher(),
};
